var version = {
    "name":      "dativery",
    "buildDateCode": "20260424-110438",
    "buildDate": "Fri Apr 24 2026 11:04:38 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260424-110438",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;